export const GET_ERRORS = "GET_ERRORS";
export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const CHANGE_AVATAR = "CHANGE_AVATAR";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const MENU_LOADER = "MENU_LOADER";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const UPDATE_PASSWORD_BY_MOBILE_SUCCESS =
  "UPDATE_PASSWORD_BY_MOBILE_SUCCESS";
export const UPDATE_PASSWORD_BY_MOBILE_FAIL = "UPDATE_PASSWORD_BY_MOBILE_FAIL";
export const UPDATE_PASSWORD_BY_OLD_PASSWORD_SUCCESS =
  "UPDATE_PASSWORD_BY_OLD_PASSWORD_SUCCESS";
